export default __webpack_public_path__ + "static/port-8-a4abc07547b54cd224624a164be6a36a.jpeg";